<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="row col-12">
        <div class="col-6">
          <button type="button" class="btn btn-primary" v-on:click="newUser()"><i class="fa fa-plus"></i>&nbsp; New User</button>
        </div>
        <div class="col-6">
          <div class="row col-12">
            <div class="col-6" style="font-weight: bold;">Freeze Trading Globally</div>
            <div class="col-6">
              <label class="switch switch-3d switch-danger" style="margin-bottom: 0">
                <input v-model="isGlobalFreeze" v-on:change="toggleFreezeGlobal()" type="checkbox" class="switch-input">
                <span class="switch-label"></span>
                <span class="switch-handle"></span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <table class="table table-bordered table-striped table-sm">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Type</th>
              <th>Customer</th>
              <th>Vendor</th>
              <th>Suspended</th>
              <!-- <th>Freeze</th> -->
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, index) in users">
              <td class="align-middle">{{user.name}}</td>
              <td class="align-middle">{{user.email}}</td>
              <td class="align-middle">
                <span v-if="user.role == 'ADMIN'">Administrator</span>
                <span v-if="user.role == 'CUST'">Customer</span>
              </td>
              <td class="align-middle">{{user.customer_name}}</td>
              <td class="align-middle">{{user.vendor_name}}</td>
              <td>
                <label class="switch switch-3d switch-danger" style="margin-bottom: 0">
                  <input v-model="user.is_suspended" v-on:change="setSuspended(index)" type="checkbox" class="switch-input">
                  <span class="switch-label"></span>
                  <span class="switch-handle"></span>
                </label>
              </td>
              <!-- <td>
                <label class="switch switch-3d switch-danger" style="margin-bottom: 0">
                  <input v-model="user.is_freeze" v-on:change="toggleFreezingModel(index)" type="checkbox" class="switch-input">
                  <span class="switch-label"></span>
                  <span class="switch-handle"></span>
                </label>
              </td> -->
              <td>
                <button v-on:click="openValueLimiter(index)" type="button" class="btn btn-primary btn-sm" style="width: 100px;">Value Limiter</button>
                <button v-on:click="editUser(index)" type="button" class="btn btn-primary btn-sm" style="width: 100px;">Edit</button>
                <button v-on:click="notifyWelcome(index)" type="button" class="btn btn-success btn-sm" style="width: 100px;">Welcome</button>
                <button v-on:click="toggleModel(index)" type="button" class="btn btn-warning btn-sm" style="width: 40px;"><i class="fa fa-times"></i></button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <b-modal title="User" class="modal-primary user-edit" v-model="editScreen" ok-title="Save" @ok="saveUser">
      <div role="group" class="form-row b-form-group form-group">
        <div class="col-12">
          <p class="error-text">{{resetMessage}}</p>
          <div role="group" class="input-group">
            <div class="input-group-addon">
              <i class="fa fa-user"></i>
            </div>
            <input v-model="currentUser.name" type="text" placeholder="User Name" class="form-control">
          </div>
          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback" style="display: none;">
            <span></span>
          </div>
        </div>
      </div>

      <div role="group" class="form-row b-form-group form-group">
        <div class="col-12">
          <div role="group" class="input-group">
            <div class="input-group-addon">
              <i class="fa fa-envelope"></i>
            </div>
            <input v-model="currentUser.email" type="email" placeholder="Email Address" class="form-control">
          </div>
          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback" style="display: none;">
            <span></span>
          </div>
        </div>
      </div>

      <div role="group" class="form-row b-form-group form-group">
        <div class="col-12">
          <div role="group" class="input-group">
            <div class="input-group-addon">
              <i class="fa fa-asterisk"></i>
            </div>
            <input v-model="currentUser.change_password" type="password" placeholder="Password" class="form-control">
          </div>
          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback" style="display: none;">
            <span></span>
          </div>
        </div>
      </div>

      <div role="group" class="form-row b-form-group form-group">
        <div class="col-12">
          <div role="group" class="input-group">
            <div class="input-group-addon">
              <i class="fa fa-user-circle"></i>
            </div>
            <select v-model="currentUser.customer_list_id" class="form-control">
              <option v-for="(customer, index) in customers" v-bind:value="customer.list_id">{{customer.name}}</option>
            </select>
          </div>
          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback" style="display: none;">
            <span></span>
          </div>
        </div>
      </div>

      <div role="group" class="form-row b-form-group form-group">
        <div class="col-12">
          <div role="group" class="input-group">
            <div class="input-group-addon">
              <i class="fa fa-user-circle-o"></i>
            </div>
            <select v-model="currentUser.vendor_list_id" class="form-control">
              <option v-for="(vendor, index) in vendors" v-bind:value="vendor.list_id">{{vendor.name}}</option>
            </select>
          </div>
          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback" style="display: none;">
            <span></span>
          </div>
        </div>
      </div>

      <div role="group" class="form-row b-form-group form-group">
        <div class="col-12">
          <div role="group" class="input-group">
            <div class="input-group-addon">
              <i class="fa fa-lock"></i>
            </div>
            <select v-model="currentUser.role" class="form-control">
              <option value="ADMIN">Administrator</option>
              <option value="CUST">Customer</option>
            </select>
          </div>
          <div role="alert" aria-live="assertive" aria-atomic="true" class="invalid-feedback" style="display: none;">
            <span></span>
          </div>
        </div>
      </div>

    </b-modal>

    <b-modal title="Delete User" class="modal-warning" ok-title="Delete" ok-only size="sm" v-model="deleteModal" @ok="deleteIndex()">
      <div class="row">
        <div class="col-12 text-center">
          <h6>Are you sure you want to delete ?</h6>
        </div>
      </div>
    </b-modal>

    <b-modal title="Value Limiter" class="modal-warning" ok-title="Save" ok-only size="lg" v-model="valueLimiterModal" @ok="saveValueLimiter()">
      <div class="row">
        <div class="col-12 text-center">
          <h6>Set the value limiter for the account of {{storeValueLimitModal.name}}.</h6>
          <br/>
          <table class="table table-bordered table-striped table-sm">
            <thead>
              <tr>
                <th class="align-center">Sales Credit Limit</th>
                <th class="align-middle">Purchase Credit Limit</th>
                <th class="align-middle">Enable</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="align-middle"><input type="number" min=1  oninput="validity.valid||(value='1')" v-model="modalLimit.purchase" class="form-control text-right form-control-sm" style="width: 80px"></td>
                <td class="align-middle"><input type="number" min=1  oninput="validity.valid||(value='1')" v-model="modalLimit.sales" class="form-control text-right form-control-sm" style="width: 80px"></td>
                <td> 
                  <label class="switch switch-3d switch-icon switch-danger" style="margin-bottom: 0">
                    <input v-model="modalLimit.enable" type="checkbox" class="switch-input">
                    <span class="switch-label"></span>
                    <span class="switch-handle"></span>
                  </label></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
    <announcement></announcement>
  </div>
</template>

<script>
  import { Announcement } from '../../components/'
  export default {
    name: 'accountList',
    components: {
      Announcement
    },
    data () {
      return {
        users: [],
        customers: [],
        vendors: [],
        currentUser: {},
        editScreen: false,
        resetMessage: '',
        resetError: false,
        isEditModeOn: false,
        deleteModal: false,
        storeDeleteModal: {},
        storeValueLimitModal: {},
        valueLimiterModal: false,
        modalLimit: {},
        freezeModal: false,
        storeFreezeModal: {},
        isGlobalFreeze: false
      }
    },
    methods: {
      newUser () {
        this.currentUser = {}
        this.editScreen = true
      },
      notifyWelcome (index) {
        this.$http.post('admin/notify-welcome', this.users[index]).then(response => {
          console.log(response)
        }, response => {
          console.log(response)
        })
      },
      deleteIndex () {
        this.$toasted.show('Deleted User', {
          theme: 'toasted-primary',
          position: 'top-center',
          duration: 500
        })
        this.$http.post('admin/user-delete', this.storeDeleteModal).then(response => {
          // console.log('deleteIndex -> response', response)
          this.getUsers()
        }, response => {
          console.log(response)
        })
      },
      toggleModel (index) {
        // console.log('deleteIndex -> this.users[index]', this.users[index])
        this.deleteModal = true
        this.storeDeleteModal = this.users[index]
      },
      saveUser (index) {
        // setting error message to false and empty string
        this.resetError = false
        this.resetMessage = ''
        // prevent it from default close
        // reference https://bootstrap-vue.org/docs/components/modal 
        index.preventDefault()
        // putting validation 
        const {name, email} = this.currentUser
        // check all fields
        if (name === undefined || name === null || email === undefined || email === null ||
        ((this.currentUser.change_password === undefined ||
        this.currentUser.change_password === null) && !this.isEditModeOn) || this.currentUser.customer_list_id === undefined ||
        this.currentUser.customer_list_id === null || this.currentUser.vendor_list_id === undefined ||
        this.currentUser.vendor_list_id === null) {
          this.resetMessage = 'All field are madatory !!'
          this.resetError = true
        }
        // checking strength of password
        if (this.resetError === false && !this.isEditModeOn && (!this.currentUser.change_password.match(/[a-z]/g) || !this.currentUser.change_password.match(/[A-Z]/g) || !this.currentUser.change_password.match(/[0-9]/g) || !this.currentUser.change_password.match(/[^a-zA-Z\d]/g) || this.currentUser.change_password.length <= 8)) {
          this.resetMessage = 'This site requires the use of strong password.   Your password must be a minimum of 8 characters and should contain at least 1 uppercase, 1 lowercase character, 1 digit, or 1 special character.'
          this.resetError = true
        }
        // checking strength of password in edit mode as well
        if (this.isEditModeOn && this.currentUser.change_password && (!this.currentUser.change_password.match(/[a-z]/g) || !this.currentUser.change_password.match(/[A-Z]/g) || !this.currentUser.change_password.match(/[0-9]/g) || !this.currentUser.change_password.match(/[^a-zA-Z\d]/g) || this.currentUser.change_password.length <= 8)) {
          this.resetMessage = 'This site requires the use of strong password.   Your password must be a minimum of 8 characters and should contain at least 1 uppercase, 1 lowercase character, 1 digit, or 1 special character.'
          this.resetError = true
        }
        if (this.resetError === false && this.currentUser.id) {
          // console.log('saveUser -> this.currentUser.id', this.currentUser)
          this.editScreen = false
          this.isEditModeOn = false
          this.$http.post('admin/user-save', this.currentUser).then(response => {
            this.getUsers()
          }, response => {
            console.log(response)
          })
        } else if (this.resetError === false) {
          this.isEditModeOn = false
          this.editScreen = false
          this.$http.post('admin/user-create', this.currentUser).then(response => {
            this.getUsers()
          }, response => {
            console.log(response)
          })
        }
      },
      editUser (index) {
        this.currentUser = this.users[index]
        this.editScreen = true
        this.isEditModeOn = true
      },
      getUsers () {
        this.$http.get('admin/users').then(response => {
          this.users = response.body
        }, response => {
          console.log(response)
        })
      },
      getCustomers () {
        this.$http.get('admin/customers').then(response => {
          this.customers = response.body
        }, response => {
          console.log(response)
        })
      },
      getVendors () {
        this.$http.get('admin/vendors').then(response => {
          this.vendors = response.body
        }, response => {
          console.log(response)
        })
      },
      openValueLimiter (index) {
        this.storeValueLimitModal = this.users[index]
        this.valueLimiterModal = true
        this.$http.post('admin/user-limit-detail', this.storeValueLimitModal).then(response => {
          if (response && response.body && response.body.success) {
            this.modalLimit = {
              purchase: response.data.data.purchase_limit,
              sales: response.data.data.sales_limit,
              enable: response.data.data.is_limit_enabled
            }
          }
        }, response => {
          console.log('openValueLimiter -> response', response)
        })
      },
      setSuspended (index) {
        console.log('setSuspended -> this.users[index]', this.users[index])
        var textSus = this.users[index].is_suspended ? 'Suspended' : 'Unsuspended'
        this.$http.post('admin/user-suspended', this.users[index]).then(response => {
          this.getUsers()
          this.$toasted.show(textSus, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 500
          })
        }, response => {
          console.log(response)
        })
      },
      saveValueLimiter () {
        this.valueLimiterModal = false
        this.modalLimit.userId = this.storeValueLimitModal.id
        this.modalLimit.purchase = this.modalLimit.purchase === '' ? 1 : this.modalLimit.purchase
        this.modalLimit.sales = this.modalLimit.sales === '' ? 1 : this.modalLimit.sales
        console.log('saveValueLimiter -> this.modalLimit', this.modalLimit)
        this.$http.post('admin/user-limit', this.modalLimit).then(response => {
          if (response && response.body && response.body.success) {
            this.$toasted.show('Value Limit setted successfully', {
              theme: 'toasted-primary',
              position: 'top-center',
              duration: 5000
            })
          } else {
            this.$toasted.show('Please set the limit value again !!', {
              theme: 'toasted-primary',
              position: 'top-center',
              duration: 5000
            })
          }
        }, response => {
          console.log(response)
        })
      },
      toggleFreezingModel (index) {
        this.freezeModal = true
        this.storeFreezeModal = this.users[index]
        this.freezeIndex()
      },
      freezeIndex () {
        this.$http.post('admin/user-freeze', this.storeFreezeModal).then(response => {
          console.log('freezeIndex -> this.storeFreezeModal.is_freeze', this.storeFreezeModal.is_freeze)
          var userFreezeText = (this.storeFreezeModal.is_freeze === true) ? 'Freeze' : 'Un-Freeze'
          this.$toasted.show(userFreezeText, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 500
          })
        }, response => {
          console.log(response)
        })
      },
      toggleFreezeGlobal () {
        this.$http.post('admin/global-freeze', {'trade_freezing': this.isGlobalFreeze}).then(response => {
          var setFreezeText = this.isGlobalFreeze ? 'Freezed' : 'Unfreezed'
          this.$toasted.show(setFreezeText, {
            theme: 'toasted-primary',
            position: 'top-center',
            duration: 500
          })
        }, response => {
          console.log(response)
        })
      },
      getGlobalFreeze () {
        this.$http.get('admin/global-freeze-details').then(response => {
          this.isGlobalFreeze = parseInt(response.body[0].setting_value)
        }, response => {
          console.log(response)
        })
      }
    },
    beforeMount () {
      this.getUsers()
      this.getCustomers()
      this.getVendors()
      this.getGlobalFreeze()
    }
  }
</script>

<style>
.error-text {
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/views/users/Users.vue